import { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import axios from "axios";

const EditArticleForm = () => {
  const { id } = useParams();
  const [post, setPost] = useState({ title: "", content: "" });
  const navigate = useNavigate();
  const API_URL = process.env.REACT_APP_API_URL || "http://localhost:5000";

  useEffect(() => {
    axios
      .get(`${API_URL}/api/posts/${id}`)
      .then((res) => setPost(res.data))
      .catch((err) => console.error("記事の取得に失敗しました", err));
  }, [id]);

  const handleChange = (e) => {
    setPost({ ...post, [e.target.name]: e.target.value });
  };

  const handleUpdate = (e) => {
    e.preventDefault();
    axios
      .put(`${API_URL}/api/posts/${id}`, post)
      .then(() => {
        alert("記事を更新しました");
        navigate("/dashboard/edit-article");
      })
      .catch((err) => {
        console.error("記事の更新に失敗しました", err);
      });
  };

  return (
    <div className="max-w-4xl mx-auto p-6 bg-white shadow-lg rounded-lg">

      <div style={{ paddingLeft: '50px' }}>
        {/* 戻るボタン */}
        < button
          type="button"
          onClick={() => navigate(-1)}
          className="mb-4 text-blue-600 hover:underline"
          style={{ display: "block", marginTop: "10px", marginBottom: "10px" }}
        >
          ← 前に戻る
        </button >
      </div>

      <div style={{ paddingLeft: '50px' }}>
        <h1 className="text-xl font-bold mb-4">記事を編集</h1>
        <form onSubmit={handleUpdate}>
          <div className="mb-4">
            <label>タイトル</label>
            <div>
              <input
                name="title"
                value={post.title}
                onChange={handleChange}
                style={{
                  width: "20%",
                  padding: "12px",
                  fontSize: "15px",
                  height: "8px",
                  marginBottom: "12px",
                }}
              />
            </div>

          </div>
          <div className="mb-4">
            <label>内容</label>
            <div>
              <textarea
              name="content"
              value={post.content}
              onChange={handleChange}
                style={{
                  width: "60%",
                  padding: "12px",
                  fontSize: "15px",
                  height: "300px",
                  marginBottom: "12px",
                }}
              />
            </div>
          </div>
          <button
            type="submit"
            className="bg-blue-600 text-white px-4 py-2 rounded"
          >
            更新する
          </button>
        </form>
      </div>
    </div>
  );
};

export default EditArticleForm;
